export const NAME = 'name'

export const getInitialValues = (editCategoryData = {}) => {
  return {
    [NAME]: editCategoryData[NAME] || ''
  }
}
